const FILTER_CONTAINER = 'data-filter-container'
const FILTER_GROUP = 'data-filter-by'
const FILTER_TARGET = 'data-filter-group'
const FILTER_RESET = 'data-filter-reset'
const FILTER_MAX_ITEMS = 'data-filter-max-items'
const FILTER_MAX_ITEMS_SHOW_ALL = 'data-filter-max-show-all'

const $containers = document.querySelectorAll(`[${FILTER_CONTAINER}]`)
const $filters = document.querySelectorAll(`[${FILTER_GROUP}]`)

function init() {
  if ($containers.length === 0 || $filters.length === 0) return
  initGroupFilters($containers, $filters)
}

function initGroupFilters($containers, $filters) {
  $containers.forEach($container => {
    const $items = $container.children;
    let maxItems = $container.getAttribute(FILTER_MAX_ITEMS) || 0;
    const $maxItemsShowAll = $container.querySelector(`[${FILTER_MAX_ITEMS_SHOW_ALL}]`);

    if (maxItems > 0 && $items.length > maxItems && $maxItemsShowAll) {
      $maxItemsShowAll.classList.remove('hidden');
      $container.classList.add('hide-all');
      for(var i = 0, len = $items.length; i < len; i++) {
        if (maxItems === 0 || (maxItems > 0 && i < maxItems)) {
          $items[i].classList.add('visible')
        }
      }

      $maxItemsShowAll.addEventListener('click', (e) => {
        for(var i = 0, len = $items.length;  i < len; i++) {
          $items[i].classList.add('visible');
        }
        $maxItemsShowAll.classList.add('hidden');
      })
    }

    $filters.forEach($filter => {
      $filter.addEventListener('click', (e) => {
        e.preventDefault()
        const filterId = $filter.getAttribute(FILTER_GROUP)
        const $targets = document.querySelectorAll(`[${FILTER_TARGET}="${filterId}"]`)

        // collateral damage, check if tab has maps, then refresh them
        $targets.forEach($target => {
          const $targetMap = $target.querySelector('[data-map-type="leaflet"]')
          if ($targetMap) {
            const maps = Drupal.geolocation.maps;
            const mapId = $targetMap.getAttribute('id');
            if (maps.length) {
              maps.forEach(map => {
                if (map.id === mapId) {
                  map.leafletMap.invalidateSize();
                }
              })
            }
          }
        });

        // remove filtered
        const $visibles = $container.querySelectorAll('.visible')
        if ($visibles.length) {
          $visibles.forEach($visible => {
            $visible.classList.remove('visible')
          })
        }
        if ($filter.hasAttribute(FILTER_RESET)) { // if index is 0 show all
          $container.classList.add('hide-all');
          for(var i = 0, len = $items.length; i < len; i++) {
            if (maxItems === 0 || (maxItems > 0 && i < maxItems)) {
              $items[i].classList.add('visible')
            }
            if (maxItems > 0 && $items.length > maxItems && $maxItemsShowAll) {
              $maxItemsShowAll.classList.remove('hidden');
            }
          }
        } else if ($targets.length) { // hide all, show filtered
          $container.classList.add('hide-all')
          $targets.forEach($target =>
            $target.classList.add('visible')
          )
          if ($maxItemsShowAll) {
            $maxItemsShowAll.classList.add('hidden');
          }
        }
      })
    });
  })
}

export default { init }
